/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ zalo_error: NonNullable<unknown> }} Error_Zns_Send_RejectedInputs */

const vi_error_zns_send_rejected = /** @type {(inputs: Error_Zns_Send_RejectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zalo từ chối gửi (mã lỗi ${i?.zalo_error}).`)
};

/**

* @param {Error_Zns_Send_RejectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_send_rejected = /** @type {((inputs: Error_Zns_Send_RejectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Send_RejectedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_send_rejected(inputs)
});